import React from 'react';
import { useTranslation } from '../../utils/useTranslation';
import { IconKebab } from '../icon/IconKebab';
import { IconButton } from '../input/IconButton';
import { Menu, MenuItem } from '../navigation/Menu';
import { Typography } from '../typography/Typography';

interface CollectionMenuProps {
    onRemove: () => void;
    onEdit: () => void;
}

export const CollectionMenu = (props: CollectionMenuProps) => {
    const { onEdit, onRemove } = props;
    const t = useTranslation();

    return (
        <Menu
            trigger={
                <IconButton color="primary">
                    <IconKebab />
                </IconButton>
            }
        >
            <MenuItem onClick={() => onEdit()}>
                <Typography noWrap>{t('Редактировать')}</Typography>
            </MenuItem>
            <MenuItem onClick={onRemove}>
                <Typography color="error" noWrap>
                    {t('Удалить')}
                </Typography>
            </MenuItem>
        </Menu>
    );
};
